import React from 'react';
import { ArrowRight } from 'lucide-react';

/**
 * Homepage Who We Are teaser — links to About page / mega menu.
 */
export default function SectionWhoWeAre({ content, onOpenAbout, onGoAbout }) {
  const data = content?.whoWeAre || content || {};
  const heading = data.heading ?? 'Who we are';
  const eyebrow = data.eyebrow ?? 'JungleBrick';
  const subtext = data.subtext ?? '';
  const points = Array.isArray(data.points) ? data.points : [];
  if (!heading && points.length === 0) return null;

  return (
    <section
      id="whoweare"
      className="py-12 sm:py-16 border-t"
      style={{ background: 'var(--jb-section-alt)', borderColor: 'var(--jb-border)' }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="mb-10 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <div className="max-w-2xl">
            <p className="font-mono text-xs text-cyan uppercase tracking-widest mb-2">{eyebrow}</p>
            <h2 className="font-display font-extrabold text-2xl sm:text-3xl text-text-hero mb-2">
              {heading}
            </h2>
            {subtext && <p className="font-body text-text-sub">{subtext}</p>}
          </div>
          <button
            type="button"
            onClick={onGoAbout || onOpenAbout}
            className="inline-flex items-center gap-2 font-body font-semibold text-cyan text-sm hover:opacity-90 whitespace-nowrap"
          >
            {data.ctaText ?? 'About JungleBrick'} <ArrowRight className="w-4 h-4" />
          </button>
        </div>

        {points.length > 0 && (
          <div className="grid sm:grid-cols-3 gap-5">
            {points.map((point, i) => (
              <button
                key={i}
                type="button"
                onClick={onOpenAbout || onGoAbout}
                className="text-left p-5 rounded-xl border bg-forest-card hover:border-cyan/50 transition group"
                style={{ borderColor: 'var(--jb-border)' }}
              >
                <div
                  className="font-mono text-xs text-cyan mb-3"
                >
                  {String(i + 1).padStart(2, '0')}
                </div>
                <h3 className="font-display font-bold text-text-hero mb-2 group-hover:text-cyan transition">
                  {point.title}
                </h3>
                <p className="font-body text-sm text-text-sub leading-relaxed">{point.description}</p>
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
